/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import 'iconify-icon';
import './app/core/icons/offline-icons'; // register the app's icons offline (no api.iconify.design fetch)
(window as any).global = window

bootstrapApplication(AppComponent, appConfig)
.catch((err) => console.error(err));
